import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  addToCollection (context, data) {
    context.commit('UPDATE_FILELIST', data)
  },
  delete (context, data) {
    let path = 'file/delete'
    Vue.axios.post(path, { filename: data.filename })
      .then(response => {
        context.commit('REMOVE_FROM_FILELIST', response.data)
      })
      .catch(error => {
        console.log(error.response.status)
      })
  },
  async getData (context) {
    context.commit('SET_FILELIST', (await Vue.axios.get('file/list')).data)
  },
  clearList (context) {
    context.commit('SET_FILELIST', [])
  },
  async createMediumFromFile (context, file) {
    let path = 'medium'
    let mediumCreated = await Vue.axios.post(path, file)
      .then(response => {
        context.commit('REMOVE_FROM_FILELIST', response.data.File)
        return response.data
      })
      .catch(error => {
        console.log(error)
      })
    return mediumCreated
  },
  updateCollection (context, data) {
    context.commit('UPDATE_FILELIST', data)
  },
  activateWsListener (context) {
    Vue.$io.socket.off('file_conversion_progress')
    Vue.$io.socket.on('file_conversion_progress', data => {
      if (!this.state.User.liveMode.mediaConvertions) return
      context.commit('UPDATE_FILELIST', data)
      context.commit('SET_FILES_WHERE_CHANGED_BY_WS', true)
    })
  },
  setUploadingFiles (context, files) {
    context.commit('SET_FILES_UPLOADING', files)
  },
  filesWhereSeen (context) {
    context.commit('SET_FILES_WHERE_CHANGED_BY_WS', false)
  },
  deactivateWsListener (context) {
    Vue.$io.socket.off('file_conversion_progress')
  },
  addSelectedLeft (context, data) {
    context.commit('ADD_SELECTED_LEFT', data)
  },
  addSelectedRight (context, data) {
    context.commit('ADD_SELECTED_RIGHT', data)
  }
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/file/file.actions.js
// module id = null
// module chunks = 